import { useState } from "react";

import { useAnlageStatusLinkAnzeigen, useAnlageStatusLinkErneuern, useAnlageStatusLinkSperren } from "../api/hooks";
import type { Anlage, StatusLinkAusgabe } from "../api/typen";
import { useToast } from "../kontext/ToastKontext";
import { zeitpunkt } from "../lib/format";
import { Knopf } from "./Basis";
import { StatusLinkModal } from "./StatusLinkModal";

/** Status-Link im Backoffice: anzeigen (immer derselbe, solange aktiv), bewusst erneuern, sperren. */
export function StatusLinkBereich({ anlage }: { anlage: Anlage }) {
  const anzeigen = useAnlageStatusLinkAnzeigen(anlage.id);
  const erneuern = useAnlageStatusLinkErneuern(anlage.id);
  const sperren = useAnlageStatusLinkSperren(anlage.id);
  const toast = useToast();
  const [ausgabe, setAusgabe] = useState<StatusLinkAusgabe | null>(null);

  function linkAnzeigen() {
    anzeigen.mutate(undefined, {
      onSuccess: setAusgabe,
      onError: (e) => toast.fehler(e, "Status-Link konnte nicht geladen werden"),
    });
  }

  function linkErneuern() {
    if (!window.confirm("Neuen Status-Link erzeugen? Der bisherige Link funktioniert danach nicht mehr.")) return;
    erneuern.mutate(undefined, {
      onSuccess: setAusgabe,
      onError: (e) => toast.fehler(e, "Status-Link konnte nicht erneuert werden"),
    });
  }

  function linkSperren() {
    if (!window.confirm("Status-Link sperren? Der Kunde kann seinen Link danach nicht mehr öffnen.")) return;
    sperren.mutate(undefined, {
      onSuccess: () => toast.info("Status-Link gesperrt", "Der bisherige Link funktioniert nicht mehr."),
      onError: (e) => toast.fehler(e, "Sperren fehlgeschlagen"),
    });
  }

  return (
    <div className="flex flex-col items-end gap-1 text-xs">
      <div className="flex items-center gap-2">
        {anlage.status_link_vorhanden && !anlage.status_link_gesperrt && (
          <span className="text-neutral-500">
            Status-Link aktiv{anlage.status_link_erzeugt_am && ` seit ${zeitpunkt(anlage.status_link_erzeugt_am)}`}
          </span>
        )}
        {anlage.status_link_gesperrt && <span className="text-neutral-400">Status-Link gesperrt</span>}
        <Knopf className="!px-3 !py-1.5" laedt={anzeigen.isPending} onClick={linkAnzeigen}>
          {anlage.status_link_vorhanden && !anlage.status_link_gesperrt ? "Link anzeigen" : "Status-Link erzeugen"}
        </Knopf>
        {anlage.status_link_vorhanden && !anlage.status_link_gesperrt && (
          <>
            <Knopf variante="geist" className="!px-2 !py-1.5" laedt={erneuern.isPending} onClick={linkErneuern}>
              Neu erzeugen
            </Knopf>
            <Knopf variante="geist" className="!px-2 !py-1.5" laedt={sperren.isPending} onClick={linkSperren}>
              Sperren
            </Knopf>
          </>
        )}
      </div>
      {ausgabe && <StatusLinkModal ausgabe={ausgabe} schliessen={() => setAusgabe(null)} />}
    </div>
  );
}
